import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { TaxPayerType } from './types'

interface EditProps {
  tax_payer: TaxPayerType
  categories: { id: string; name: string }[]
  areas: { id: string; name: string }[]
  communities: { id: string; name: string }[]
}

export default function Edit({ tax_payer, categories, areas, communities }: EditProps) {
  return (
    <>
      <Head title="Editing tax payer" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing tax payer</h1>

        <Form
          tax_payer={tax_payer}
          categories={categories}
          areas={areas}
          communities={communities}
          action={`/tax_payers/${tax_payer.id}`}
          method="patch"
          submitText="Update Tax payer"
        />

        <Link
          href={`/tax_payers/${tax_payer.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Show this tax payer
        </Link>
        <Link
          href="/tax_payers"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to tax payers
        </Link>
      </div>
    </>
  )
}
